import styled from 'styled-components';

export const GanttDropdown = styled.div`
  display: flex;
  align-items: center;
  margin-right: 34px;
  & > div {
    width: 288px;
  }
`;

export const TrialPeriodWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 36px;
  & > div:first-child {
    margin-right: 4px;
  }
`;
